import { AnalyticsEvent, Tracker } from './tracker';
import type { AnalysisType } from './events';

export type { AnalysisType };

export const ANALYSIS_ROUTE_TYPES: Record<string, AnalysisType> = {
  '/analysis/rentability': 'rentability',
  '/analysis/evolution': 'evolution',
  '/analysis/earnings': 'earnings',
  '/analysis/projection': 'projection',
  '/analysis/fiis': 'fiis',
};

export function analysisTypeFromRoute(route: string): AnalysisType | undefined {
  return ANALYSIS_ROUTE_TYPES[route];
}

export function trackAnalysisViewed(
  analysisType: AnalysisType,
  source = 'page_load',
): void {
  Tracker.track(AnalyticsEvent.WebAnalysisViewed, {
    analysis_type: analysisType,
    source,
  });
}

export function trackAnalysisNavTapped(analysisType: AnalysisType): void {
  Tracker.track(AnalyticsEvent.WebAnalysisNavTapped, { analysis_type: analysisType });
}

export function trackAnalysisMenuOpened(): void {
  Tracker.track(AnalyticsEvent.WebAnalysisMenuOpened);
}

export function trackAnalysisExported(analysisType: AnalysisType): void {
  Tracker.track(AnalyticsEvent.WebAnalysisExported, { analysis_type: analysisType });
}

export function trackAnalysisPeriodChanged(
  analysisType: AnalysisType,
  preset: string,
): void {
  Tracker.track(AnalyticsEvent.WebAnalysisPeriodChanged, {
    analysis_type: analysisType,
    preset,
  });
}

export function trackAnalysisFilterApplied(
  analysisType: AnalysisType,
  filterName: string,
): void {
  Tracker.track(AnalyticsEvent.WebAnalysisFilterApplied, {
    analysis_type: analysisType,
    filter_name: filterName,
  });
}

export function trackAnalysisGroupByChanged(
  analysisType: AnalysisType,
  groupBy: string,
): void {
  Tracker.track(AnalyticsEvent.WebAnalysisGroupByChanged, {
    analysis_type: analysisType,
    group_by: groupBy,
  });
}
